import type {PrismicRichTextProps} from '@prismicio/react'

import type {ConsentWebsiteFragment} from '@helios/website/src/graphql-types'

export interface Props {
    isExplicit: boolean
    consentsState: ConsentsState
    consents: MappedConsents
    error?: string
    onConsentChange: OnConsentChange
    type: ConsentTypes
}
export interface UseConsentsLogicReturn {
    consentsProps: Props
    validateConsents: () => boolean
    consentsPayload?: ConsentsPayload
    ConsentTypes: typeof ConsentTypes
}
export interface CommunicationConsent {
    id: number
    required: boolean
}

export interface UseConsentsProps {
    communicationConsents: CommunicationConsent[]
    imperativeConsents?: ImperativeConsent[]
    type: ConsentTypes
}
export interface UseConsentsLogicProps extends UseConsentsProps {
    consents: Consent[]
}

export interface ConsentsState {
    process: {error: boolean; value: boolean}
    [key: number]: {error: boolean; value: boolean}
}

export interface MappedConsents {
    process: PrismicRichTextProps['field']
    communication: Array<{
        id: number
        label: PrismicRichTextProps['field']
        required: boolean
    }>
}

export type OnConsentChange = (consent: keyof ConsentsState, value: boolean) => void

export enum ConsentTypes {
    'Communication' = 'communication',
    'Legitimate interest' = 'legitimate_interest',
    'Process - explicit' = 'explicit_consent_to_process',
    'Process - implicit' = 'implicit_consent_to_process',
    'None' = 'none',
}

export interface ImperativeConsent {
    consent: {
        document: ConsentWebsiteFragment
    }
}

export enum ReversedConsentTypes {
    'communication' = 'Communication',
    'legitimate_interest' = 'Legitimate interest',
    'explicit_consent_to_process' = 'Process - explicit',
    'implicit_consent_to_process' = 'Process - implicit',
    'none' = 'None',
}

export interface FormConfig {
    formId: string
    consents: UseConsentsProps
}

export interface ConsentsPayload {
    consentToProcess: boolean
    text: string
    communications: Array<{
        value: boolean
        subscriptionTypeId: number
        text: string | PrismicRichTextProps['field'] | null
    }>
}

export interface Consent {
    type: string
    isDefault: boolean
    subscriptionTypeStaging: {
        subscriptionId: number
    }
    subscriptionTypeProduction: {
        subscriptionId: number
    }
    text: {
        richText: any
    }
}
